import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, Field, change } from 'redux-form'
import compose from 'recompose/compose'

import { Card } from '@/ui/Card'
import { Container, Row, Column, Cell, Flex } from '@/ui/Element'
import { InputField, ImageInput } from '@/ui/Input'
import Button from '@/ui/Button/Button'
import ImageField from '@/ui/Data/ImageField'

import { goToPage as goToPageAction } from '@/state/actions/routes'
import { crudUpdate as crudUpdateAction } from '@/state/actions/data'

import translate from '@/i18n/translate'

class EditUser extends Component {
  renderImage = props => (
    <ImageInput
      {...props}
      theme={this.props.theme}
      source="image"
      label="Image"
      accept="image/*"
      placeholder={
        <div>
          <span>
            Image, JPG, PNG<br />min. size 360 x 360 px
          </span>
          <p>DROP IMAGE TO UPLOAD</p>
        </div>
      }
    >
      <ImageField source="src" title="title" theme={this.props.theme} />
    </ImageInput>
  )

  shouldComponentUpdate(nextProps, nextState) {
    // Prevent update when animating away, it's causing password field to dissapear since the
    //  nextProps.id is undefined, and the field gets removed causing the card to jump due to
    // lower height
    if (nextProps.me === this.props.me && nextProps.id === undefined) {
      return false
    }
    return true
  }

  saveUser = record => {
    this.props.crudUpdate('users', this.props.id, record, this.props.initialValues, false, {
      message: `${record.full_name || this.props.initialValues.full_name} updated.`,
    })
  }

  goBack = () => {
    this.props.dispatch(this.props.goToPage(this.props.currentRouteData.parent))
  }

  render() {
    const {
      theme,
      handleSubmit,
      submitting,
      me,
      initialValues: data = {},
      // translate,
      // ...rest
    } = this.props
    const boxClass =
      me !== data.id ? [theme['square-box'], theme['edit-user']].join(' ') : theme['square-box']

    return (
      <Container>
        <Column>
          <form className="form" onSubmit={handleSubmit(this.saveUser)}>
            <Cell>
              <Card classes={['v-padding-large', 'colored-card']}>
                <Row gutter="large">
                  <Cell size="33" dir="vertical">
                    <Field
                      name="picture"
                      component={this.renderImage}
                      classes={boxClass}
                      id="picture"
                    />
                  </Cell>
                  <Cell size="66">
                    <Field
                      name="full_name"
                      labelText="Full name:"
                      component={InputField}
                      placeholder="Full name"
                      id="full_name"
                    />
                    <Field
                      name="phone"
                      labelText="Phone:"
                      component={InputField}
                      placeholder="Phone"
                      id="phone"
                    />
                    <Field
                      name="email"
                      labelText="E-Mail address:"
                      component={InputField}
                      placeholder="you@elovade.com"
                      id="email"
                    />
                    <If condition={me === data.id}>
                      <Field
                        name="password"
                        type="password"
                        labelText="Password (min. 6 characters):"
                        component={InputField}
                        id="password"
                      />
                    </If>
                  </Cell>
                </Row>
              </Card>
            </Cell>
            <Flex horz="right" classes={['top-margin']}>
              <Button
                theme={theme}
                styles="right-margin"
                disabled={submitting}
                onClick={this.goBack}
              >
                Cancel
              </Button>
              <Button
                theme={theme}
                type="submit"
                classes={['secondary']}
                styles="h-padding-large"
                disabled={submitting}
              >
                Save
              </Button>
            </Flex>
          </form>
        </Column>
      </Container>
    )
  }
}

function mapStateToProps(state, props) {
  const userId = state.location.payload.id
  return {
    id: userId,
    me: state.auth.user.id,
    initialValues: state.rest.users.data[userId],
    isLoading: state.rest.loading > 0,
  }
}

const enhance = compose(
  connect(mapStateToProps, {
    goToPage: goToPageAction,
    crudUpdate: crudUpdateAction,
    change: change,
  }),
  translate,
  reduxForm({
    form: 'editUser',
    validate: (values, props) => {
      const errors = {}
      const { translate } = props
      ;['full_name', 'email', 'phone'].forEach(field => {
        if (!values[field]) errors[field] = translate('i18n.validation.required')
      })
      return errors
    },
  }),
)

export default enhance(EditUser)



// WEBPACK FOOTER //
// ./view/Users/editUser.js